const saveValue = (key, value) => {
  try {
    const serializedData = JSON.stringify(value);
    localStorage.setItem(key, serializedData);
  } catch (err) {
    throw new Error('Cannot save to local store!')
  }
};

const loadValue = (key) => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (err) {
    throw new Error('Cannot load value from local store!')
  }
};

const removeValue = (key) => localStorage.removeItem(key);

export { saveValue, loadValue, removeValue };
